// extracted by mini-css-extract-plugin
export default {"backdrop":"BulkDownloadModal-backdrop_ojJ","modal":"BulkDownloadModal-modal__MT"};